<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="actions" slot-scope="{ item }">
                <b-btn
                    title="Asignar usuarios"
                    size="sm"
                    variant="primary"
                    @click="$emit('user-assign', item)"
                >
                    <i class="fa fa-users"></i>
                </b-btn>
                <b-btn
                    title="Personas Evaluadas"
                    size="sm"
                    variant="primary"
                    @click="$emit('people-evaluated', item)"
                >
                    <i class="fa fa-check-square-o" aria-hidden="true"></i>
                </b-btn>
                <b-btn size="sm" variant="primary" @click="$emit('edit', item)">
                    <i class="fa fa-pencil"></i>
                </b-btn>
                <b-btn
                    size="sm"
                    variant="danger"
                    @click="$emit('delete', item)"
                >
                    <i class="fa fa-trash"></i>
                </b-btn>
            </template>
            <template
                slot="initial_qualification_period"
                slot-scope="{ item }"
                >{{ item.initial_qualification_period | date }}</template
            >
            <template slot="final_qualification_period" slot-scope="{ item }">{{
                item.final_qualification_period | date
            }}</template>
            <template slot="max_evaluation_date" slot-scope="{ item }">{{
                item.max_evaluation_date | date
            }}</template>
            <template slot="max_actions_plan_date" slot-scope="{ item }">{{
                item.max_actions_plan_date | date
            }}</template>
            <template slot="deadline" slot-scope="{ item }">{{
                item.deadline | date
            }}</template>
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [Array, Object],
            default: '',
        },
        onChangePage: {
            type: Function,
        },
    },
    data: () => ({
        fields,
    }),
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
const fields = [
    {
        key: 'name',
        label: 'Nombre',
    },
    {
        key: 'registered_by.name',
        label: 'Usuario creador',
        orderBy: 'registered_by_id',
    },
    {
        key: 'initial_qualification_period',
        label: 'Período inicial',
    },
    {
        key: 'final_qualification_period',
        label: 'Período final',
    },
    {
        key: 'max_evaluation_date',
        label: 'Fecha maxima de calificación',
    },
    {
        key: 'max_actions_plan_date',
        label: 'Fecha maxima a presentar plan',
    },
    {
        key: 'deadline',
        label: 'Fecha de cierre',
    },
    {
        key: 'notes',
        label: 'Notas',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
